import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Lang, Dir } from 'src/app/shared/lang';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  dir: Dir = Dir.ltr;
  lang: Lang = Lang.en;
  rtlLang = ['ar'];

  constructor(private translateService: TranslateService) { }

  changeLanguage(selectedLanguage: Lang) {
    this.translateService.use(selectedLanguage);
    const ele = document.querySelector('html');
    const tDir = this.rtlLang.includes(selectedLanguage) ? Dir.rtl : Dir.ltr;

    this.dir = tDir;
    this.lang = selectedLanguage;
    if (ele) {
      ele.dir = tDir;
      ele.lang = selectedLanguage;
    }
  }

  get getRtlClass() {
    return this.dir === Dir.rtl ? 'rtl' : '';
  }
}
